<template>

  <div class="btn-group" role="group">
    <button type="button" class="btn btn-xs dropdown-toggle dropdown-toogle-no-icon" @click.stop="isVisible = !isVisible" aria-haspopup="true" aria-expanded="false">
      <slot>
        <font-awesome-icon :icon="['far', 'ellipsis-h']" size="lg" />
      </slot>
    </button>
    <div v-if="isOrganization && false" class="dropdown-menu" :class="{ show: isVisible }" style="left: -120px">
      <router-link :to="'/referral/' + item.id" class="dropdown-item" v-if="!isOrganization">
        <font-awesome-icon :icon="['far', 'edit']" class="mr-2" />Edit
      </router-link>
      <router-link :to="`/op-report/?to=${item.practice.id}&referral=${item.id}`" class="dropdown-item" v-for="org in organizations" :key="org.id">
        <font-awesome-icon icon="share-all" class="mr-2" />{{org.name}}
      </router-link>
    </div>
    <div v-else class="dropdown-menu" :class="{ show: isVisible }" style="left: -120px">
      <template v-if="!isOrganization">
        <router-link :to="'/referral/' + item.id" class="dropdown-item">
          <font-awesome-icon :icon="['far', 'edit']" class="mr-2" />Edit
        </router-link>
        <a href="javascript:void(0)" @click.stop="$helpers.copyReferral(item)" class="dropdown-item">
          <font-awesome-icon :icon="['far', 'clone']" class="mr-2" />Copy
        </a>
        <router-link :to="'/referral/print/' + item.id" target="_blank" class="dropdown-item">
          <font-awesome-icon :icon="['far', 'print']" class="mr-2" />Print
        </router-link>
        <div class="dropdown-divider" v-if="!item.sent_time || $helpers.isSchedulable(item) || item.is_incoming"></div>
      </template>
      <router-link :to="`/op-report/?to=${item.practice.id}&referral=${item.id}`" class="dropdown-item" v-if="item.is_incoming">
        <font-awesome-icon :icon="['far', 'file-medical']" class="mr-2" />Send Op Report
      </router-link>
      <router-link :to="'/referral/send/' + item.id" :title="`Send to ${item.to_practice.name}`" class="dropdown-item" v-if="!item.sent_time" :class="{disabled: !!item.sent_time, 'text-primary': !item.sent_time}">
        <font-awesome-icon :icon="['far', 'paper-plane']" class="mr-2" />Send
      </router-link>
      <router-link :to="'/referral/schedule/' + item.id" class="dropdown-item" v-if="$helpers.isSchedulable(item)">
        <font-awesome-icon :icon="['far', 'calendar']" class="mr-2" />
        {{ item.scheduled_time ? 'Reschedule' : 'Schedule' }}
      </router-link>
      <div class="dropdown-divider"></div>
      <a href="javascript:void(0)" @click.stop="$helpers.closeReferral(item, 'cancelled_time', 'Cancel Referral')" class="dropdown-item" :class="{disabled: item.cancelled_time || item.completed_time }">
        <font-awesome-icon :icon="['far', 'times-circle']" class="mr-2" />Cancel
      </a>
      <a href="javascript:void(0)" @click.stop="$helpers.completeReferral(item)" class="dropdown-item" v-if="$helpers.isCompletable(item) || $helpers.isFollowupCompletable(item)">
        <font-awesome-icon :icon="['far', 'check-circle']" class="mr-2" />Complete
      </a>
      <template v-if="!isOrganization">
        <div class="dropdown-divider"></div>
        <router-link :to="'/referral/history/' + item.id" class="dropdown-item">
          <font-awesome-icon :icon="['far', 'sticky-note']" class="mr-2" />Add Note
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.closeDropDownHandler = (() => (this.isVisible = false)).bind(this)
    document.body.addEventListener('click', this.closeDropDownHandler)
  },
  data() {
    return { isVisible: false, closeDropDownHandler: null }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['isLoggedIn', 'isOrganization']),
    organizations() {
      return this.user.practice.organizations.filter(
        (s) => s.id != this.item.to_practice.id
      )
    },
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.closeDropDownHandler)
  },
}
</script>

<style>
</style>